<!-- hero carousel row -->
<div class="row carousel-row">
  <div class="col carousel-col" *ngIf="isBrowser()">
    <carousel [showIndicators]="true" [isAnimated]="true" [interval]="0">

      <slide style="height: 531px;">
        <img class="img-fluid mx-auto carousel-image"
          src="/assets/site/images/home-banners/carousel-image1.png" alt="large vats containing foodstuffs">
        <div class="carousel-caption text-left container">
          <h1>Markez® FFKM</h1>
          <h5>Our exclusive FFKM compounds provide unmatched value while delivering top-of-the-line performance. 
            Many sizes in-stock.
          </h5>
          <button class="btn btn-primary mt-20" routerLink="/markez-ffkm.htm">Experience Markez</button>
        </div>
      </slide>

      <slide style="height: 531px;">
        <img class="img-fluid mx-auto carousel-image"
          src="/assets/site/images/home-banners/carousel-image2.png" alt="Solar">

        <div class="carousel-caption text-left container">
          <h1>Great Seals, Great Results</h1>
          <h5>The seals you use matter. From custom shapes and materials to complex sizes and more, our application 
            experts will help you find the best option.
          </h5>
          <button class="btn btn-primary mt-20" routerLink="/inquiry-quote.htm">Request a Quote</button>
        </div>
      </slide>

      <slide style="height: 531px;">
        <img class="img-fluid mx-auto carousel-image"
          src="/assets/site/images/home-banners/carousel-image3.png" alt="glass vials on an assembly line">
        <div class="carousel-caption text-left container">
          <h1>Medical-Grade O-Rings & Seals</h1>
          <h5>Learn about the various materials and products available to help you meet USP Class VI 
            compliance requirements.  Use a variety of filters to find the right material for your 
            application and buy online.
          </h5>
          <button class="btn btn-primary mt-20" routerLink="/medical-o-rings.htm">Explore Medical Solutions</button>
        </div>
      </slide>

      <slide style="height: 531px;">
        <img class="img-fluid mx-auto carousel-image"
          src="/assets/site/images/home-banners/carousel-image4.png" alt="large fluidic manufacturing apparatus">
        <div class="carousel-caption text-left container">
          <h1>Get Performance Without Delays</h1>
          <h5>Having trouble finding the material you need for your application? With Markez®, our in-house custom FFKM material, 
            you'll get the same performance without production delays — or excess costs.
          </h5>
          <button class="btn btn-primary mt-20" routerLink="/store">Browse In-Stock Seals</button>
        </div>
      </slide>

      <slide style="height: 531px;">
        <img class="img-fluid mx-auto carousel-image"
          src="/assets/site/images/home-banners/carousel-image5.png" alt="vast array pressurized pipes">
        <div class="carousel-caption text-left container">
          <h1>Four Decades of Expertise</h1>
          <h5 style="width: 50%">Explore case studies of how companies across multiple industries are putting our materials to work for success, 
            and gain insights directly from our application experts into specific products, materials, and more.
          </h5>
          <button class="btn btn-primary mt-20" routerLink="/blog">Grow Your Knowledge</button>
        </div>
      </slide>


    </carousel>
  </div>
  <div class="col carousel-col" *ngIf="!isBrowser()">
    <div style="height: 531px;">
      <img class="img-fluid mx-auto carousel-image flip-img"
        src="/assets/site/images/home-banners/new-banner-solar.jpg" alt="Solar">

      <div class="carousel-caption text-left container">
        <h1>Success Starts with the Right Seal</h1>
        <p>Cheap seals are costly - in more ways than one. For more than 40 years, Marco Rubber &
          Plastics has been helping thousands of companies worldwide find the right sealing product for
          their application, and we're ready to help you. Talk to an application engineer today.
        </p>
        <a [routerLink]="['/inquiry-quote.htm']" class="btn btn-info font-weight-bold">Request a Quote</a>
      </div>
    </div>
  </div>
</div>
<!-- END hero carousel row -->

<!-- products & services row -->
<div class="container">
<div class="row products-services-row">
  <div class="col products-services-row-container">
    <div class="card-deck">
      <div class="card products-services-card">
        <img alt="O-Rings and Basic Seals Suppliers" class="product-img card-img-top img-fluid"
          src="/assets/site/images/home-products/oring.png" />
        <div class="card-body d-flex flex-column">
          <div class="card-title">
            <h4>O-Rings & Basic Seals</h4>
          </div>
          <p>
            Explore thousands of custom and commodity sealing solutions for
            multiple applications.
          </p>
          <a [routerLink]="['/o-rings-basic-seals-index.htm']"
            class="btn btn-primary mt-auto products-services-link">Learn More</a>
        </div>
      </div>

      <div class="card products-services-card">
        <img alt="Performance Seals Suppliers" class="product-img card-img-top img-fluid"
          src="/assets/site/images/home-products/capseal.png" />
        <div class="card-body d-flex flex-column">
          <div class="card-title">
            <h4>Performance Seals</h4>
          </div>
          <p>
            From spring-energized seals to glide and backup rings, we have the
            performance seal you need.
          </p>
          <a [routerLink]="['/performance-seal-index.htm']" class="btn btn-primary mt-auto products-services-link">Learn
            More</a>
        </div>
      </div>
      <div class="w-100 d-none d-sm-block d-md-none">

      </div>
      <div class="w-100 d-none d-md-block d-lg-none">
      </div>

      <div class="card products-services-card">
        <img alt="Custom Molded and Gaskets Suppliers" class="product-img flip-img card-img-top img-fluid"
          src="/assets/site/images/home-products/custom-wbg.png" />
        <div class="card-body d-flex flex-column">
          <div class="card-title">
            <h4>Custom Molded & Gaskets</h4>
          </div>
          <p>
            Explore our range of custom-molded seals and other components for
            your specific applications.
          </p>
          <a [routerLink]="['/custom-molded-rubber-gasket-products.htm']"
            class="btn btn-primary mt-auto products-services-link">Learn More</a>
        </div>
      </div>

      <div class="card products-services-card">
        <img alt="Engineering Services" class="product-img card-img-top img-fluid"
          src="/assets/site/images/home-products/calipers.png" />
        <div class="card-body d-flex flex-column">
          <div class="card-title">
            <h4>Engineering Services</h4>
          </div>
          <p>
            From inspection and design support to coatings and cleaning, our engineers
            are ready to help.
          </p>
          <a [routerLink]="['/o-ring-services-index.htm']" class="btn btn-primary mt-auto products-services-link">Learn
            More</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END products & services row -->

<!-- Why Marco row -->
<div class="row">
  <div>
    <h2>Why Marco Rubber & Plastics?</h2>
    <p>
      Marco Rubber & Plastics offers the most diverse material options in the market.
      We supply o-rings and seals in any size, material,<br /> durometer and performance
      requirements. Specialty material development and design support are typically available at no cost.
    </p>
  </div>
</div>

<div class="row pt-4 why-marco-row">
  <div class="col">
    <div class="row why-card-row">
      <div class="col-md-6 col-lg-4 why-cell">
        <div class="card why-card">
          <table class="why-table">
            <tr style="vertical-align: top">
              <td class="why-icon-cell">
                <img class="home-icon" src="/assets/site/images/home-icons/icon-service.png" />
              </td>
              <td class="why-text-cell">
                <h3>Exceptional Service</h3>
                <p>
                  Talk to our experienced professionals to find creative product and service solutions. 
                  Typical office hours are M-F 8:30 am-5:00 pm EST. We respond to email in hours if not minutes.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 why-cell">

        <div class="card why-card">
          <table class="why-table">
            <tr style="vertical-align: top">
              <td class="why-icon-cell">
                <img class="home-icon" src="/assets/site/images/home-icons/icon-knowledge.png" />
              </td>
              <td class="why-text-cell">
                <h3>Product Expertise</h3>
                <p>
                  The Marco sales team is backed by expert engineers available for on-demand conference
                  calls to offer application specific material and design support to meet any sealing
                  challenge.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 why-cell">

        <div class="card why-card">
          <table class="why-table">
            <tr style="vertical-align: top">

              <td class="why-icon-cell">
                <img class="home-icon" src="/assets/site/images/home-icons/icon-customization.png" />
              </td>
              <td class="why-text-cell">
                <h3>Customizable Solutions</h3>
                <p>
                  We work with you to tailor our products and services to match your requirements, or provide a fully custom solution. Get custom o-rings, square rings, and x-rings 
                  in nearly any material.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 why-cell">

        <div class="card why-card">
          <table class="why-table">
            <tr style="vertical-align: top">
              <td class="why-icon-cell">
                <img class="home-icon" src="/assets/site/images/home-icons/icon-product.png" />
              </td>
              <td class="why-text-cell">
                <h3>Responsive & Fast</h3>
                <p>
                  Our integrated o-ring inventory network allows us to have real-time access 
                  to in-stock materials and provide fast, accurate quotes so you can be confident 
                  your order is en route.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 why-cell">

        <div class="card why-card">
          <table class="why-table">
            <tr style="vertical-align: top">

              <td class="why-icon-cell">
                <img class="home-icon" src="/assets/site/images/home-icons/icon-materials.png" />
              </td>
              <td class="why-text-cell">
                <h3>Specialized Materials</h3>
                <p>
                  We offer 3,000+ materials that deliver performance and price advantages for your 
                  application. Popular materials like Kalrez, Viton, and Parker are in-stock, many 
                  with same-day shipping.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 why-cell">

        <div class="card why-card">
          <table class="why-table">
            <tr style="vertical-align: top">
              <td class="why-icon-cell">
                <img class="home-icon" src="/assets/site/images/home-icons/icon-pricing.png" />
              </td>
              <td class="why-text-cell">
                <h3>Excellent Value</h3>
                <p>
                  We consult with you to learn the unique requirements of your application and help build a solution that provides the performance you need while staying on time and on budget.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- END Why Marco? row -->

    <div class="home-iso-section">
      <div class="home-iso-text row">
        <div class="col-md-10">
          <h3>ISO 9001:2015 Certified by NQA</h3>
          <p>Our Quality Management System (QMS) is ISO 9001:2015 Certified by NQA, demonstrating our dedication to continuous improvement, innovative and adaptive leadership, evidence-based decision making, and top-of-the-line quality management. </p>
        </div>
        <div class="col-md-2">
          <img style="height:150px;width:100px;" src="/assets/img/NQA_ISO9001_CMYK.jpg">
        </div>
      </div>
    </div>

    <!-- homepage contact form -->
    <div class="contact-form-bgimage">
      <div class="row contact-form-row">
        <div class="offset-md-1 col-md-5">
          <h2>Have Questions?</h2>
          <h3 class="text-white">
            Connect With An Expert
          </h3>
          <ul class="contact-points p-3">
            <li>
              Expert product, application and design assistance
            </li>
            <li>
              Trusted by 14,000+ customers
            </li>
            <li>
              Fast response (asap within hours)
            </li>
            <li>
              Same day shipping for most in stock products
            </li>
            <li>
              3,000+ custom sealing material formulations
            </li>
          </ul>
          <div class="card question-block-contact-info">
            <h5>Fill out the form or give us a call.</h5>
            <div><fa-icon [icon]="faPhone" size="sm"></fa-icon> Give us a call: <a href="tel:6034683600" class="text-bold">(603) 468-3600</a></div>
          </div>
        </div>
        <div class="col-md-5 contact-box p-4">
          <form id="homepage-form" [formGroup]="inquiryQuoteForm" (ngSubmit)="onSubmit()">
            <input type="hidden" formControlName="form_name" />
            <div class="form-row">
              <div
                [ngClass]="{'form-group col':true, 'has-danger': fullname.touched && fullname.errors, 'has-success': fullname.valid }">
                <label for="fullname">Full Name</label> 
                <div class="inline-asterix">
                  <input id="fullname"
                    [ngClass]="{'form-control': true, 'form-control-success': fullname.valid, 'form-control-danger': fullname.touched && fullname.errors }"
                    formControlName="fullname" name="fullname" type="text" placeholder="Enter your first and last name" value="" />
                </div>
                <div *ngIf="fullname.touched && fullname.errors?.required" class="form-control-feedback">Name is
                  required.</div>
              </div>
            </div>

            <div class="form-row">
              <div
                [ngClass]="{'form-group col':true, 'has-danger': email.touched && email.errors, 'has-success': email.valid }">
                <label for="email">Email</label>
                <div class="inline-asterix">
                  <input id="email"
                  [ngClass]="{'form-control': true, 'form-control-success': email.valid, 'form-control-danger': email.touched && email.errors }"
                    placeholder="Enter your email address (name@example.com)" formControlName="email" name="email" type="text" value="" />
                </div>
                <div *ngIf="email.touched && email.errors?.required" class="form-control-feedback">Email is
                  required.
                </div>
                <div *ngIf="email.touched && email.errors?.email" class="form-control-feedback">Please enter a valid email.
                </div>
              </div>
            </div>


            <div class="form-row">
              <div
                [ngClass]="{'form-group col':true, 'has-danger': phone.touched && phone.errors, 'has-success': phone.valid }">
                <label for="phone">Phone</label>
                <div class="inline-asterix">
                  <input id="phone"
                    [ngClass]="{'form-control': true, 'form-control-success': phone.valid, 'form-control-danger': phone.touched && phone.errors?.required }"
                    placeholder="_ _ _-_ _ _-_ _ _ _" formControlName="phone" name="phone" type="text" value="" />
                </div>
                <div *ngIf="phone.touched && phone.errors?.required" class="form-control-feedback">Phone is
                  required.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div
                [ngClass]="{'form-group col-md-12':true, 'has-danger': company.touched && company.errors, 'has-success': company.valid }">
                <label for="company">Company</label>
                <div class="inline-asterix">
                  <input id="company" placeholder="Enter your company name" class="form-control" formControlName="company"
                    name="company" type="text" value="" />
                </div>
                <div *ngIf="company.touched && company.errors?.required" class="form-control-feedback">Company is
                  required.
                </div>
              </div>
            </div>


            <div class="form-row">
              <div
                [ngClass]="{'form-group col-md-12':true, 'has-danger': message.touched && message.errors, 'has-success': message.valid }">
                <label for="message">Message (optional)</label>
                <div class="inline-asterix">
                  <textarea id="message" class="form-control" placeholder="Enter your message here" formControlName="message"
                    [ngClass]="{'form-control': true, 'form-control-success': message.valid, 'form-control-danger': message.errors }"
                    name="message" type="text" value=""></textarea>
                </div>
              </div>
            </div>



            <div class="rfq-bottom">
              <input class="btn btn-primary font-weight-bold contact-form-submit-button" name="submit" type="submit"
                value="Connect with an Expert" />
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- END homepage contact form -->


    <!-- N-Market ROW -->
    <div class="row industry-row-title">
      <div class="col-md-12">
        <h2>Delivering Proven Performance for Multiple Industries</h2>
        <p class="pb-4">
          Every industry is unique. We understand the challenges you're facing
          and will match you with the best sealing solution for your success.
          Explore our industry expertise below.
        </p>

        <div class="row industry-row">
          <div class="col-md-6 col-lg-4 industry-cell">
            <div class="card pb-2">
              <img class="card-img" src="/assets/site/images/industry-apps/semiconductor.jpg" />
              <div class="card-img-overlay">
                <h3 class="text-white">Semiconductor, Solar, LCD</h3>
                <a [routerLink]="['/semiconductor-o-rings.htm']" class="btn btn-primary">Learn More</a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 industry-cell">
            <div class="card pb-2">
              <img class="card-img" src="/assets/site/images/industry-apps/foodwater.jpg" />
              <div class="card-img-overlay">
                <h3 class="text-white">Food, Water, Life Sciences</h3>
                <a [routerLink]="['/fda-o-rings-food-grade.htm']" class="btn btn-primary">Learn More</a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 industry-cell">
            <div class="card pb-2">
              <img class="card-img" src="/assets/site/images/industry-apps/aerospace.jpg" />
              <div class="card-img-overlay">
                <h3 class="text-white">Aerospace & Military</h3>
                <a [routerLink]="['/o-ring-mil-specs-chart.htm']" class="btn btn-primary">Learn More</a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 industry-cell">
            <div class="card pb-2">
              <img class="card-img" src="/assets/site/images/industry-apps/oilgas.jpg" />
              <div class="card-img-overlay">
                <h3 class="text-white">Oil & Gas Refining & Exploration</h3>
                <a [routerLink]="['/oil-gas-o-ring-seal-industry.htm']" class="btn btn-primary">Learn More</a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 industry-cell">
            <div class="card pb-2">
              <img class="card-img" src="/assets/site/images/industry-apps/chemical.jpg" />
              <div class="card-img-overlay">
                <h3 class="text-white">Chemical Handling & Processing</h3>
                <a [routerLink]="['/cpi.htm']" class="btn btn-primary">Learn More</a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 industry-cell">
            <div class="card pb-2">
              <img class="card-img" src="/assets/site/images/industry-apps/electronics.jpg" />
              <div class="card-img-overlay">
                <h3 class="text-white">Electronics - EMI Shielding</h3>
                <a [routerLink]="['/emi-o-rings.htm']" class="btn btn-primary">Learn More</a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- END N-Market ROW -->

    <!-- MATERIAL FAMILIES ROW -->
    <div class="row material-families-row">
      <div class="offset-md-1 col-md-10">
        <h2>Popular Materials</h2>
        <p>We're proud to offer the world's largest inventory of readily-available and highly customized sealing
          solutions.
          Explore some of the most common sealing materials we offer here.</p>

        <div class="material-families-table">
          
            
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/markez-o-rings.htm']" class="material-link">Markez&reg; O-Rings FFKM</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/fluorosilicone-o-rings.htm']" class="material-link">Fluorosilicone O-Rings FVMQ</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/polyurethane-o-rings.htm']" class="material-link">Polyurethane O-Rings</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/epdm-o-rings.htm']" class="material-link">EPDM O-Rings</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/chemraz-o-rings.htm']" class="material-link">Chemraz&reg; O-Rings FFKM</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/viton-o-rings.htm']" class="material-link">Viton&reg; O-Rings FKM</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/teflon-encapsulated-o-rings.htm']" class="material-link">FEP (Teflon)
                  Encapsulated</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/parker-o-rings.htm']" class="material-link">Parker O-Ring Materials</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/buna-n-o-rings.htm']" class="material-link">Buna-N O-Rings NBR</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/aflas-o-rings.htm']" class="material-link">Aflas&reg; O-Rings FEPM FTE/P</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/hnbr-o-rings.htm']" class="material-link">HNBR O-Rings</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/silicone-o-rings.htm']" class="material-link">Silicon O-Rings VMQ</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/teflon-o-rings.htm']" class="material-link">TeflonN&reg; O-Rings PTFE</a>
              </div>
              <div class="material-family-table-cell-div">
                <a [routerLink]="['/o-ring-material-selection-comparison.htm']" class="material-link">Popular Materials
                  Comparison</a>
              </div>

        </div>
      </div>
    </div>
    <!-- END MATERIAL FAMILIES ROW -->


    <!-- Reference guides row -->
    <div class="row reference-guide-title-row">
      <div class="offset-sm-1 col-sm-10">
        <h2>Sealing References</h2>
        <p>Looking for design guides and technical information? We've got you covered. Find size guides, analyses,<br />
          and more in our library of reference guides developed by our material experts.</p>



        <div class="row reference-guide-row pt-4">
          <div class="col-sm-12 col-md-6 col-lg-4 pb-4">
            <div class="card reference-card">
              <div class="card-body">
                <div class="card-title">
                  <h3>Material Selection Gude</h3>
                </div>
                <p>
                  Explore o-ring materials to compare temperature, performance, chemical resistance, abrasion, and more.
                </p>
                <a [routerLink]="['/o-ring-material-selection-comparison.htm']"
                  class="btn btn-info guide-button">View
                  Guide</a>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 pb-4">
            <div class="card reference-card">
              <div class="card-body">
                <div class="card-title">
                  <h3>O-Ring Size Charts</h3>
                </div>
                <p>
                  Browse in-depth charts on o-ring and sealing product sizes to find the right seal for your application.
                </p>
                <a [routerLink]="['/o-ring-size-chart-index.htm']" class="btn btn-info guide-button">View Guide</a>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 pb-4">
            <div class="card reference-card">
              <div class="card-body">
                <div class="card-title">
                  <h3>O-Ring Tolerances</h3>
                </div>
                <p>
                  View inside diameter and cross section tolerance levels for o-rings in different size measurements.
                </p>
                <a [routerLink]="['/o-ring-tolerance-index.htm']" class="btn btn-info guide-button">View Guide</a>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 pb-4">
            <div class="card reference-card">
              <div class="card-body">
                <div class="card-title">
                  <h3>O-Ring Groove Design Guide</h3>
                </div>
                <p>
                  Groove design is critical to o-ring success. Learn key considerations and browse guides here.
                </p>
                <a [routerLink]="['/o-ring-groove-design-directory.htm']" class="btn btn-info guide-button">View
                  Guide</a>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 pb-4">
            <div class="card reference-card">
              <div class="card-body">
                <div class="card-title">
                  <h3>Chemical Compatibility Guide</h3>
                </div>
                <p>
                  Browse and compare o-ring compatibility ratings and costs with thousands of chemical types.
                </p>
                <a [routerLink]="['/o-ring-chemical-compatibility-chart.htm']" class="btn btn-info guide-button">View
                  Guide</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<!-- END Reference guides row -->
